import { LOGOUT } from '@/redux/actions/auth.actions'
import { EMPTY_ORDERS_LIST, FETCH_ORDERS_LIST } from '@/redux/actions/orders.actions'

const initialState = {
	loading: false,
	error: false,
	list: [],
	meta: {}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_ORDERS_LIST.REQUEST:
			return action.payload.resetList
		case FETCH_ORDERS_LIST.SUCCESS:
		case FETCH_ORDERS_LIST.FAILURE:
			return false
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case FETCH_ORDERS_LIST.REQUEST:
		case FETCH_ORDERS_LIST.SUCCESS:
			return false
		case FETCH_ORDERS_LIST.FAILURE:
			return true
		default:
			return state
	}
}

const list = (state = initialState.list, action) => {
	switch (action.type) {
		case FETCH_ORDERS_LIST.REQUEST:
			return action.payload.resetList
				? [...new Array(action.payload.itemsToLoad)]
				: [...state, ...new Array(action.payload.itemsToLoad)]

		case FETCH_ORDERS_LIST.SUCCESS: {
			const { docs: moreOrdersFetched } = action.payload
			const loadedOrders = [...state.slice(0, state.length - action.payload.itemsToLoad), ...moreOrdersFetched]
			return loadedOrders
		}

		case FETCH_ORDERS_LIST.FAILURE:
			return state.slice(0, state.length - action.payload.itemsToLoad)

		case EMPTY_ORDERS_LIST:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return []

		default:
			return state
	}
}

const meta = (state = initialState.meta, action) => {
	switch (action.type) {
		case FETCH_ORDERS_LIST.SUCCESS: {
			const { docs: _docs, ...meta } = action.payload

			return meta
		}
		case FETCH_ORDERS_LIST.FAILURE:
		case FETCH_ORDERS_LIST.REQUEST:
			return {}
		default:
			return state
	}
}

export default {
	name: 'orders',
	reducers: {
		list,
		meta,
		loading,
		error
	}
}
